<template>
	<CommonTable
		:headers="headers"
		:items="items"
		:sortBy="sortBy"
		:total="total" :limit="limit" :offset="offset"
		@update:sortBy="$emit('update:sortBy', $event)"
		@update:limit="$emit('update:limit', $event)"
		@update:offset="$emit('update:offset', $event)"
		:noDataText="$t('text.noDigitalContractTemplatesAvailable')"
	>
		<template #[`item.name`]="{ item }">
			<div>{{ cleanName(item.name) }}</div>
		</template>

		<template #[`item.contractSequenceType`]="{ item }">
			<Chip :title="$t(`text.contractSequenceType${item.contractSequenceType?.charAt(0).toUpperCase() + item.contractSequenceType?.slice(1) || ''}`)" />
		</template>

		<template #[`item.startDate`]="{ item }">
			<div>{{ formatDate(item.startDate) }}</div>
		</template>

		<template #[`item.hasAtLeastOneContract`]="{ item }">
			<v-icon :color="item.hasAtLeastOneContract ? '#64C823' : '#F34545'">{{ item.hasAtLeastOneContract ? 'mdi-check' : 'mdi-close' }}</v-icon>
		</template>

		<!-- <template #[`item.productKinds`]="{ item }">
			<div :style="'display: flex; gap: 10px; flex-wrap: wrap;'">
				<template v-for="(category, index) in item.productKinds">
					<Chip v-if="index < 2" :key="`category-${index}`" :title="category" />
				</template>
				<Chip v-if="item.productKinds.length > 2" :key="`category-${index}`" :title="`+ ${item.productKinds.length - 2} ${ $t('text.more') }`" />
			</div>
		</template> -->

		<template #[`item.actions`]="{ item }">
			<div>
				<v-btn class="my-2" variant="outlined" icon="mdi-pencil" rounded="lg"
					@click="$router.push('/contractTemplate?id=' + item.id)" />
			</div>
		</template>
	</CommonTable>
</template>

<script lang="ts">
import Common from '../../mixins/Common.vue'
import CommonTable from '../common/tables/Table.vue'
import Chip from '../common/controls/Chip.vue'
import type { ContractTemplateForList } from '../../../../api2/src/modules/contract/ContractTechnical'

export default {
	name: 'ContractTemplatesTable',
	components: { CommonTable, Chip },
	mixins: [ Common ],
	emits: [ 'update:limit', 'update:offset' ],
	props: {
		items: { type: Array as () => ContractTemplateForList[], default: () => [] },
		total: Number,
		limit: Number,
		offset: Number,
		sortBy: Array,
	},
	computed: {
		headers() {
			return [
				{ title: this.$t('text.name'), key: 'name', value: 'name' },
				{ title: this.$t('text.contractSequenceType'), key: 'contractSequenceType', value: 'contractSequenceType' },
				{ title: this.$t('text.startDate'), key: 'startDate', value: 'startDate' },
				{ title: this.$t('text.contractTemplateContractsAssigned'), key: 'hasAtLeastOneContract', value: 'hasAtLeastOneContract' },
				// { title: this.$t('text.eCommerceCategory'), key: 'productKinds', value: 'productKinds' },
				{ title: '', key: 'actions', value: 'actions', width: '50px', sortable: false },
			]
		}
	},
	methods: {
		cleanName(name) {
			const nameByLocale = name || {}
			const selected = nameByLocale[this.selectedLocale]?.trim()
			const fallback = nameByLocale[this.defaultLocale?.code]?.trim()
			const label = selected
				|| fallback
				|| Object.values(nameByLocale).find(value => value?.trim())
				|| ''
			return label.replace(/<.+\/>/g, '')
		},
	}
}
</script>
